/**
 * Parse Google Places address_components into a flat address object.
 *
 * @param {object} place - Google Places result with address_components
 * @param {object} options
 * @param {boolean} options.stateAsObject - Return state as { id, name } instead of short_name string
 * @param {boolean} options.includeAddress2 - Include address_2 from subpremise
 * @returns {object} Parsed address data
 */
export function parseAddressComponents(place, { stateAsObject = true, includeAddress2 = true } = {}) {
    const addressData = {
        address: '',
        city: '',
        state: null,
        zip: '',
    }

    if (includeAddress2) {
        addressData.address_2 = ''
    }

    for (const component of place.address_components) {
        const types = component.types

        if (types.includes('street_number')) {
            addressData.address = component.long_name
        } else if (types.includes('route')) {
            addressData.address += ' ' + component.long_name
        } else if (includeAddress2 && types.includes('subpremise')) {
            addressData.address_2 = component.long_name
        } else if (types.includes('postal_code')) {
            addressData.zip = component.long_name
        } else if (types.includes('locality')) {
            addressData.city = component.long_name
        } else if (types.includes('sublocality_level_1') && !addressData.city) {
            addressData.city = component.short_name
        } else if (types.includes('administrative_area_level_1')) {
            addressData.state = stateAsObject
                ? { id: component.short_name, name: component.long_name }
                : component.short_name
        }
    }

    return addressData
}
